import {memo} from 'react';
import clsx from 'clsx';
import {useTranslation} from 'react-i18next';
import _isEqual from 'lodash/isEqual';
import {PadlockCloseIcon} from '../../../../../../../../../../components/icons/icons';
import Typography from '@mui/material/Typography';
import AgyleTextField from '../../../../../../../../../../components/ui/fields/agyleTextField';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import {useDailyCalendarTileStyles} from './dailyCalendarTileStyles';

const LockedSlotTile = ({ temporaryLock, event, deleteTemporaryLockedSession, changeLockedReason }) => {
  const { t } = useTranslation();
  const classes = useDailyCalendarTileStyles();

  return (
    <div
      className={clsx(classes.lockedContainer, classes.animation)}
      style={{ justifyContent: !temporaryLock ? "center" : "space-between" }}
    >
      {!temporaryLock && (
        <>
          <PadlockCloseIcon />
          <Typography variant="subtitle1">
            {t(event?.lockedReason) || event?.reason || "Locked"}
          </Typography>
        </>
      )}

      {temporaryLock && event?.locked && (
        <>
          <AgyleTextField
            value={event?.lockedReason}
            onClick={(e) => e.stopPropagation()}
            onChange={(e) => {
              e.stopPropagation();

              if (changeLockedReason) {
                changeLockedReason(event, e.target.value);
              }
            }}
            style={{
              width: "100%",
              marginTop: 3,
              justifySelf: "center",
              marginLeft: "30%",
              marginRight: "30%",
            }}
            label={t("Reason")}
          />

          <IconButton
            style={{ color: "black" }}
            onClick={(e) => {
              e.stopPropagation();

              if (deleteTemporaryLockedSession) {
                deleteTemporaryLockedSession(event?.id);
              }
            }}
          >
            <CloseIcon />
          </IconButton>
        </>
      )}
    </div>
  );
}

export default memo(LockedSlotTile, _isEqual);